<div class="flex flex-col items-center">
  <app-shared-svg src="assets/icons/medical-history-completed.svg" class="mb-8 block h-24 w-24"></app-shared-svg>
  <h2 class="heading-xxl mb-6" data-e2e-mh-success-heading>Thanks for completing your medical history</h2>
</div>
<div class="mb-12 mt-6">
  <dentr-site-contact-details-banner></dentr-site-contact-details-banner>
</div>
<dentr-secure-connection-banner></dentr-secure-connection-banner>
